import { useSelector } from 'react-redux';
import { getPropertyValue } from 'framework-listing-lib/utils/crmObject';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import FormPermissionsActionPanel from 'asset-actions-lib-forms/permissions/FormPermissionsActionPanel';
import { hasFormsWriteAccess, hasBusinessUnitAccess } from 'FormsUI/selectors/Scope';
import { usePopover } from 'FormsUI/components/dashboard/frameworkTable/OpenPopoverProvider';
import { PROPERTIES } from 'FormsUI/components/dashboard/frameworkTable/constants';
import BusinessUnitTagContainer from 'FormsUI/components/common/BusinessUnitTagContainer';
import { Link } from 'foundations-components/transitional/components/Link';
import { ListsIcon } from 'foundations-assets/icons/components/ListsIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ManageAccessBulkAction = props => {
  const {
    trackAction,
    selectedObjects
  } = props;
  const canWriteToForms = useSelector(hasFormsWriteAccess);
  const businessUnitAccess = useSelector(hasBusinessUnitAccess);
  const formIds = selectedObjects.map(crmObject => getPropertyValue(crmObject, PROPERTIES.FORM_ID));
  const businessUnitIds = selectedObjects.map(crmObject => Number(getPropertyValue(crmObject, PROPERTIES.BUSINESS_UNIT_IDS)));
  const {
    showPopover,
    hidePopover
  } = usePopover();
  const Popover = /*#__PURE__*/_jsx(FormPermissionsActionPanel, {
    formGuids: formIds,
    formBusinessUnitsIds: businessUnitIds,
    onClosePanel: hidePopover,
    track: trackAction,
    BusinessUnitTagContainer: BusinessUnitTagContainer,
    hasBusinessUnitsAccess: businessUnitAccess
  });
  return /*#__PURE__*/_jsx(Tooltip, {
    placement: "left",
    disabled: canWriteToForms,
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "dashboard.table.permissions.disallowed"
    }),
    children: /*#__PURE__*/_jsxs(Link, {
      disabled: !canWriteToForms,
      onClick: () => showPopover(Popover),
      "data-action": "manage-access",
      children: [/*#__PURE__*/_jsx(ListsIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "assignUsersAndTeams"
      })]
    })
  });
};
export default ManageAccessBulkAction;